import React, { Component } from 'react'
import ConfiguratorSection from './../ConfiguratorSection'
import ConfiguratorImage from './../ConfiguratorImage'
import ConfiguratorOption from './../ConfiguratorOption'
import MaterialSelector from '../MaterialSelector';
import { withTranslation, Trans } from 'react-i18next'
import { interiorView04ImageOptions } from './views/InteriorView04'

class Xr41Aftcabin extends Component {
  constructor (props) {
    super(props)
     this.handleFabricChange = this.handleFabricChange.bind(this)
  }

   handleFabricChange (newValue) {
    let configuration = this.props.configuration
    configuration.Fabric = newValue

    if (this.props.onChange) {
      this.props.onChange(configuration)
    }
  }

	render() {
		let imageOptions = interiorView04ImageOptions;

    let image = (
      <ConfiguratorImage
        boat='Xr41'
        configuration={this.props.configuration}
        options={imageOptions}
      />
    )

    return (
      <ConfiguratorSection image={image}>
        <ConfiguratorOption>
          <h1>
            <Trans defaults='Aft cabins' />
          </h1>

          <p>
            <Trans defaults='The fabric choice is shared with the saloon.' />
          </p>

          {this.props.configuration.Layout.value !== 3 ? (
            <MaterialSelector
              options={this.props.FabricOptions}
              label={this.props.configuration.Fabric.label}
              value={this.props.configuration.Fabric}
              onChange={this.handleFabricChange}
            />
          ) : (
            <p>
              <Trans defaults='Fabric options are not available for the Race layout.' />
            </p>
          )}

        </ConfiguratorOption>
      </ConfiguratorSection>
    )
  }
}

export default withTranslation()(Xr41Aftcabin)



// WEBPACK FOOTER //
// ./src/Xr41/Xr41Aftcabin.js